module.exports = __webpack_public_path__ + "media/favicons/favicon-4edd2a76.ico";